// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



// WEBPACK FOOTER //
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.map.of.js